import z from "zod"

export const GetReveniReturnInfoSchema = z.object({
  orderId: z.string(),
})

export const ReveniStoreSchema = z.object({
  name: z.string().trim().min(1),
  apiKey: z.string().trim().min(1),
})

export const UpsertReveniIntegrationSchema = z.object({
  stores: z
    .array(ReveniStoreSchema)
    .min(1)
    .superRefine((stores, context) => {
      const names = new Set<string>()
      const apiKeys = new Set<string>()

      stores.forEach((store, index) => {
        const normalizedName = store.name.toLowerCase()

        if (names.has(normalizedName)) {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            path: [index, "name"],
            message: "Store names must be unique",
          })
        }

        if (apiKeys.has(store.apiKey)) {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            path: [index, "apiKey"],
            message: "API keys must be unique",
          })
        }

        names.add(normalizedName)
        apiKeys.add(store.apiKey)
      })
    }),
})
